import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Autocomplete, AutocompleteProps } from 'formik-mui';
import { useSnackbar } from 'notistack';
import { useDebounce } from 'use-debounce';

import { CissTextField } from 'components/fields/';
import { RequestListagemProps, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

interface StateOptionsProps {
    idEstado: number;
    dsEstado: string;
    sgEstado: string;
    dsCidade: string;
    idCidade: number;
}

interface RequestListagemType extends RequestListagemProps {
    data: StateOptionsProps[];
}

interface StateFieldProps extends AutocompleteProps<StateOptionsProps, boolean | undefined, boolean | undefined, boolean | undefined> {
    label: string;
    state: string;
}

export function CityFieldFormik({ onChange, multiple = true, state = '', label = 'Cidade', ...PropsFormik }: StateFieldProps) {
    const [open, setOpen] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>('');
    const [query, setQuery] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const RequestListagem = useRequestListagem();
    const [queryValue] = useDebounce(query, 500);

    const requestOptions: RequestOptionsType = {
        url: '/gestao/cidade',
        query: queryValue,
        sort: [{ property: 'sgEstado', direction: 'ASC' }],
        columns: 'idCidade,dsCidade',
        limit: 50,
    };

    const { isLoading, fetchStatus, data } = useQuery(
        [requestOptions],
        () => {
            const request: Promise<RequestListagemType> = RequestListagem(requestOptions).then((res) => res.data);
            return request;
        },
        {
            keepPreviousData: false,
            enabled: open,
            onError: () => {
                enqueueSnackbar('Falha ao processar solicitação das Cidades', { variant: 'error' });
            },
        },
    );

    useEffect(() => {
        if (open) {
            setQuery(inputValue);
        }
    }, [inputValue, open]);

    return (
        <Autocomplete
            {...PropsFormik}
            multiple={multiple}
            onChange={onChange}
            loading={isLoading && fetchStatus === 'fetching'}
            options={data?.data ?? []}
            isOptionEqualToValue={(option, value) => option.idCidade === value.idCidade}
            getOptionLabel={(option: StateOptionsProps | string) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.dsCidade;
            }}
            renderInput={(params) => <CissTextField {...params} label={label} />}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            renderOption={(props, option) => (
                <Box component="li" {...props} key={option.idCidade}>
                    {option.dsCidade}
                </Box>
            )}
        />
    );
}
